import { paletteNames } from './Palette.types';

const typographyVariants = {
    heading2: 'h2',
    heading3: 'h3',
    heading4: 'h4',
    body: 'p',
    caption: 'span',
    label: 'label'
}
const defaultTypoVariant = typographyVariants.body;

const typographySizes = {
    none: '',
    heading3: 'heading3',
    heading4: 'heading4',
    body: 'body',
    caption: 'caption',
    title: 'title'
}
const defaultTypoSize = typographySizes.none;

const typographyColors = paletteNames
const defaultTypoColor = paletteNames.black;

const typographyWeights = {
    light: 'light',
    regular: 'regular',
    bold: 'bold',
    black: 'black'
}
const defaultTypoWeight = typographyWeights.regular;

const typographyTransform = {
    initial: 'initial',
    uppercase: 'uppercase',
    lowercase: 'lowercase',
    capitalize: 'capitalize'
}
const defaultTypoTransform = typographyTransform.initial;

export {
    typographyVariants,
    defaultTypoVariant,
    typographySizes,
    defaultTypoSize,
    typographyColors,
    defaultTypoColor,
    typographyWeights,
    defaultTypoWeight,
    typographyTransform,
    defaultTypoTransform
}